import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { AppConfig } from "src/app/configs/app.config";
import { PermissionService } from "src/app/core/services/permisson.service";
import { UserService } from "src/app/core/services/user.service";
import {
  NON_API_ADV_ROLES,
  API_ROLES,
  AGN_LVL_ROLES,
  AGN_ADV_LVL_ROLES,
  PLATFORM_ROLES,
} from "src/app/models/common";
import { getRoleAndDefaultPageMapping } from "src/app/shared/utils/commonUtils";

@Component({
  selector: "app-main-layout",
  templateUrl: "./main-layout.component.html",
  styleUrls: ["./main-layout.component.scss"],
})

export class MainLayoutComponent implements OnInit {
  userRole: string = ''
  showSideBar: boolean = true;
  redirectPath;

  ispfmRole: boolean = false;
  params = {};

  advertiserId = null;
  agencyId =  null;
  agcAdvId = null;

  isShowChatPanel: boolean = false;
  minimizeChatPanel: boolean = false;
  chatBotEnabled: boolean = false;
  apnxEnabled: boolean = false;
  uriFirstIndex: string;

  minimizeChatIcon: boolean = false;
  readonly imgPath: string;
  readonly whiteLabelMode: boolean;

  constructor(
    private router: Router,
    private permissionService: PermissionService,
    private userService: UserService
  ) {
    this.imgPath = AppConfig.POPUP_LOGO;
    this.whiteLabelMode = AppConfig.WHITE_LABEL_MODE;
  }

  ngOnInit(): void {
    this.redirectPath = this.router.url;
    this.userRole = localStorage.getItem('role')
    this.ispfmRole = PLATFORM_ROLES.has(this.userRole);
    this.advertiserId = localStorage.getItem('advertiser_id')
    this.agencyId = localStorage.getItem('agency_id')
    this.agcAdvId = localStorage.getItem('agency_advertiser_id')
    if (this.userRole == 'advertiser_primary_admin' && this.permissionService.getCreatePermissions('political_ack') &&
      JSON.parse(localStorage.getItem('clientVertical')) && !JSON.parse(localStorage.getItem('acknowledged'))) {
    }
    let sidenav_params = {};
    sidenav_params['component'] = 'all';
    if(this.advertiserId)
      sidenav_params['advertiser_id'] = this.advertiserId;
    if(this.agencyId)
      sidenav_params['agency_id'] = this.agencyId;
    sidenav_params = {...sidenav_params,...this.params}
    if(this.redirectPath === '' || this.redirectPath === '/' && !this.userRole){
      this.router.navigate(["/signin"]);
      return
    }
    this.userService.getClientSettingData(sidenav_params).subscribe((res)=>{
      let client_tier = res.data.insertion_order.view
      client_tier = client_tier == false ? 'lite' : 'professional'

      if (this.redirectPath === '' || this.redirectPath === '/') {
        const {redirectPath, params} = getRoleAndDefaultPageMapping(this.userRole)
        this.redirectPath = redirectPath;
        this.params = { ...this.params, ...params};
      }

      if ((this.userRole == 'advertiser_primary_admin' || this.userRole == 'advertiser_admin' || this.userRole == 'advertiser_user') &&
      (localStorage.getItem('clientVertical')== 'political' || client_tier == 'lite') && (this.router.url === "" || this.router.url === '/') ) {
        this.redirectPath = '/campaign';
      }

      if(this.userRole == 'finance_user'){
        this.redirectPath = '/agency';
      }

      if (NON_API_ADV_ROLES.has(this.userRole)) {
        this.params['advertiser_id'] = this.advertiserId
      } else if (AGN_LVL_ROLES.has(this.userRole)) {
        this.params['agency_id'] = this.agencyId;
      } else if (AGN_ADV_LVL_ROLES.has(this.userRole)) {
        this.params['agency_advertiser_id'] = this.agcAdvId;
      }

    this.params = Object.keys(this.getParams(this.redirectPath)).length > 0 ? this.getParams(this.redirectPath) : this.params;

    this.redirectPath = this.getUrl(this.redirectPath);

    if (!(this.router.url == '/profile/myaccount')){
      this.router.navigate([this.redirectPath], {
        queryParams: this.params
      });
    }

    if(!this.ispfmRole) this.getConfig();

    this.router.events.subscribe(value => {
      this.uriFirstIndex = this.router.url.split('?')[0].split('/')[1];
      if (value instanceof NavigationEnd) {
        this.showSideBar = value.url !== '/help';
      }
    });
  })
  }

  getConfig() {
    this.permissionService
      .getConfig(
        this.agencyId
          ? this.agencyId
          : this.advertiserId
          ? this.advertiserId
          : this.agcAdvId,
        this.agencyId
          ? "agency"
          : this.advertiserId
          ? "advertiser"
          : "agency-advertiser"
      )
      .subscribe((res) => {
        this.chatBotEnabled =  res.data.chatbot_enabled;
        this.apnxEnabled =  res.data.apnx_enabled;
      },(err) => {},() => {
        if(this.userRole == 'agency_advertiser_reporting_user') {
          this.chatBotEnabled = false;
        }
      });
  }

  getParams(url_with_params: string) {
    if (!url_with_params) return {}
    let string_params_set = url_with_params.split('?')[1]
    if (!string_params_set) return {}
    let string_params = string_params_set.split('&')
    let params = {}
    string_params.forEach(param => {
      params[param.split('=')[0]] = param.split('=')[1]
    });
    return params
  }

  getUrl(url_with_params: string) {
    return url_with_params.split('?')[0]
  }

  isDisplayChatPanel() {
    !this.minimizeChatPanel
      ? (this.isShowChatPanel = !this.isShowChatPanel)
      : this.minimizeChatPanel = false ;
  }

  minimizePanel() {
    this.minimizeChatPanel = true;
  }

}
